import React, { useState, useEffect } from "react";
import {
  Box, Card, CardContent, Typography, Grid, IconButton,
  Button,

} from "@mui/material";
import { ShoppingCart as ShoppingCartIcon, Home as HomeIcon, Receipt as ReceiptIcon, ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../AuthProvider";
import "./Marketing.css";
import {
  marketingNavCategories,
  marketingCategoryProducts,
} from "./marketingSchoolCatalog";

const Marketing = () => {
  const navigate = useNavigate();
  const { oId, board, userId, role, pId } = useAuth();

  const [selected, setSelected] = useState(null);
  const [slide, setSlide] = useState(0);

  const navStyle = {
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    padding: "8px 12px",
    borderRadius: "10px",
    transition: "0.3s",
    "&:hover": {
      background: "#f1f3ff",
      color: "#4f5cf1",
    },
  };



  const categories = marketingNavCategories;

  const next = () => {
    setSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prev = () => {
    setSlide((prev) =>
      prev === 0 ? heroSlides.length - 1 : prev - 1
    );
  };


  const heroSlides = [
    {
      category: "Classroom Essentials",
      title: "Upgrade Your Classrooms",
      desc: "Whiteboards, desks, chairs & teaching kits",
      offer: "Flat 20% OFF",
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350", // classroom
    },
    {
      category: "Office & Administration Items",
      title: "Run Your School Smoothly",
      desc: "Printers, files, stationery & admin tools",
      offer: "Buy 2 Get 1 Free",
      image: "https://images.unsplash.com/photo-1497032205916-ac775f0649ae",
    },
    {
      category: "Digital Infrastructure",
      title: "Go Digital Smartly",
      desc: "Smart boards, CCTV, biometric systems",
      offer: "Save up to 30%",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
    },
    {
      category: "Library Items",
      title: "Build Knowledge Spaces",
      desc: "Bookshelves, academic books & journals",
      offer: "Flat 15% OFF",
      image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66",
    },
    // {
    //   category: "Science Lab Items",
    //   title: "Equip Your Labs",
    //   desc: "Physics, Chemistry & Biology lab kits",
    //   offer: "Up to 25% OFF",
    //   image: "https://images.unsplash.com/photo-1581091012184-5c2f7c1b9a7a",
    // },
    {
      category: "Sports Equipment",
      title: "Boost Physical Activity",
      desc: "Indoor & outdoor sports gear",
      offer: "Special Combo Deals",
      image: "https://images.unsplash.com/photo-1517649763962-0c623066013b",
    },
  ];

  const renderProductSections = (data) => {
    return Object.entries(data).map(([title, products]) => (
      <Box key={title} sx={{ mb: 5 }}>
        {/* SECTION HEADER */}
        <Box
          sx={{
            fontSize: "20px",
            fontWeight: 800,
            mb: 2,
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 4,
              background: "#febd69",
              borderRadius: 2,
              mb: 1,
            }}
          />
          {title}
        </Box>

        {/* PRODUCT ROW */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            overflowX: "auto",
            pb: 2,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
          className="custom-sidebar-scrollbar"
        >
          {products.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: "0 0 190px",
                minWidth: 190,
                background: "#fff",
                borderRadius: "10px",
                border: "1px solid #e5e7eb",
                overflow: "hidden",
                cursor: "pointer",
                transition: "0.25s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 25px rgba(0,0,0,.15)",
                },
              }}
            >
              <Box
                component="img"
                src={item.img}
                alt={item.name || title}
                sx={{
                  width: "100%",
                  height: 150,
                  objectFit: "cover",
                  background: "#f3f4f6",
                }}
              />

              <Box sx={{ p: 1.2 }}>
                <Box sx={{ fontSize: "14px", fontWeight: 700, mb: 0.5 }}>
                  {item.name || title}
                </Box>

                <Box
                  sx={{
                    color: "#b12704",
                    fontWeight: 800,
                    fontSize: "15px",
                  }}
                >
                  {item.price}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    ));
  };


  const homeOffers = [
    {
      title: "Best Selling Products",
      items: [
        { img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b", name: "Classroom Desk Set", price: "₹3,500", originalPrice: "₹4,200", rating: 4.5, discount: "17% OFF" },
        { img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8", name: "Laptop for Students", price: "₹42,000", originalPrice: "₹50,000", rating: 4.8, discount: "16% OFF" },
        { img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36", name: "Office Chair", price: "₹8,200", originalPrice: "₹10,000", rating: 4.3, discount: "18% OFF" },
      ],
    },
    {
      title: "Most Viewed Products",
      items: [
        { img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f", name: "Whiteboard Set", price: "₹1,900", originalPrice: "₹2,500", rating: 4.6, discount: "24% OFF" },
        { img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d", name: "Projector Screen", price: "₹5,800", originalPrice: "₹7,200", rating: 4.4, discount: "19% OFF" },
        { img: "https://images.unsplash.com/photo-1588072432836-e10032774350", name: "Interactive Board", price: "₹35,000", originalPrice: "₹42,000", rating: 4.7, discount: "17% OFF" },
      ],
    },
    {
      title: "Hot New Releases",
      items: [
        { img: "https://images.unsplash.com/photo-1574629810360-7efbbe195018", name: "Cricket Kit", price: "₹3,500", originalPrice: "₹4,500", rating: 4.9, discount: "22% OFF" },
        { img: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f", name: "Book Rack", price: "₹8,000", originalPrice: "₹10,000", rating: 4.5, discount: "20% OFF" },
        { img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7", name: "Teacher Desk", price: "₹6,500", originalPrice: "₹8,000", rating: 4.2, discount: "19% OFF" },
      ],
    },
  ];

  const renderHomeOffers = () => {
    return homeOffers.map((offer, index) => (
      <Box key={index} sx={{ mt: 6 }}>
        {/* Section Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                width: 4,
                height: 32,
                background: 'linear-gradient(135deg, #ff9900, #ff6600)',
                borderRadius: 2,
                mr: 2,
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                color: '#111',
                fontSize: { xs: '24px', md: '28px' },
              }}
            >
              {offer.title}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            sx={{
              borderColor: '#ff9900',
              color: '#ff9900',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: '#ff9900',
                color: '#fff',
              },
            }}
          >
            View All
          </Button>
        </Box>

        {/* Products Grid */}
        <Grid container spacing={3}>
          {offer.items.map((item, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                  },
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                {/* Discount Badge */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
                    color: '#fff',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                    fontSize: '12px',
                    fontWeight: 700,
                    zIndex: 2,
                    boxShadow: '0 2px 8px rgba(255,107,53,0.3)',
                  }}
                >
                  {item.discount}
                </Box>

                {/* Product Image */}
                <Box
                  component="img"
                  src={item.img}
                  alt={item.name}
                  sx={{
                    width: '100%',
                    height: 200,
                    objectFit: 'cover',
                  }}
                />

                <CardContent sx={{ p: 2 }}>
                  {/* Product Name */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: '#111',
                      mb: 1,
                      lineHeight: 1.3,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {item.name}
                  </Typography>

                  {/* Rating */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography sx={{ fontSize: '14px', color: '#ffa500', mr: 0.5 }}>
                      {'★'.repeat(Math.floor(item.rating))}
                      {'☆'.repeat(5 - Math.floor(item.rating))}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', color: '#666', ml: 0.5 }}>
                      ({item.rating})
                    </Typography>
                  </Box>

                  {/* Price */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                      sx={{
                        fontSize: '18px',
                        fontWeight: 800,
                        color: '#b12704',
                      }}
                    >
                      {item.price}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: '#666',
                        textDecoration: 'line-through',
                      }}
                    >
                      {item.originalPrice}
                    </Typography>
                  </Box>

                  {/* Add to Cart Button */}
                  <Button
                    variant="contained"
                    startIcon={<ShoppingCartIcon />}
                    sx={{
                      mt: 2,
                      width: '100%',
                      background: 'linear-gradient(135deg, #ff9900, #ff6600)',
                      color: '#fff',
                      fontWeight: 700,
                      textTransform: 'none',
                      borderRadius: 2,
                      '&:hover': {
                        background: 'linear-gradient(135deg, #e68a00, #cc7a00)',
                        transform: 'translateY(-2px)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    Add to Cart
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    ));
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setSlide((prev) =>
        prev === heroSlides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ mt: 7, mx: 2 }}>




      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          // padding: 3,
          minHeight: "500px",
          display: "flex",
          flexDirection: "column",

          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          overflowX: "hidden",

        }}
      >
        <CardContent>

          {/* header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "10px 18px",
              background: "rgba(255,255,255,0.75)",
              backdropFilter: "blur(12px)",
              borderBottom: "1px solid rgba(0,0,0,0.05)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.04)",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            {/* LOGO */}
            <Box
              sx={{
                fontSize: "20px",
                fontWeight: 800,
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                px: 2,
                py: 0.6,
                borderRadius: "10px",
                cursor: "pointer",
                boxShadow: "0 8px 20px rgba(79,92,241,.35)",
              }}
            >
              MapEdu
            </Box>

            {/* HOME */}
            <Box
              onClick={() => setSelected("Home")}
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: selected === "Home" ? "#4f5cf1" : "#1d1d1f",
                background:
                  selected === "Home"
                    ? "rgba(79,92,241,0.12)"
                    : "transparent",
                transition: "0.25s",
                "&:hover": {
                  background: "rgba(79,92,241,0.15)",
                  color: "#4f5cf1",
                },
                display: 'flex', alignItems: 'center', gap: 0.5
              }}
            >
              <HomeIcon fontSize="small" /> Home
            </Box>


            {/* SEARCH BAR */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                background: "#f1f3ff",
                borderRadius: "12px",
                px: 2,
                py: 0.5,
                maxWidth: "600px",
                transition: "0.3s",
                "&:focus-within": {
                  boxShadow: "0 0 0 2px #4f5cf1",
                  background: "#fff",
                },
              }}
            >
              <Box sx={{ fontSize: "18px", mr: 1, color: "#4f5cf1" }}>🔍</Box>

              <input
                placeholder="Search schools, services, tools..."
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  fontSize: "14px",
                }}
              />
            </Box>


                       {/* SHOP */}
            {/* <Box sx={navStyle}>Shop</Box> */}
            <Box
              sx={{ ...navStyle, display: 'flex', alignItems: 'center', gap: 0.5 }}
              onClick={() => navigate("/shop")}
            >
              <ShoppingCartIcon fontSize="small" /> Shop
            </Box>
            {/* <Box sx={navStyle}>Orders</Box> */}
            <Box
              sx={{ ...navStyle, display: 'flex', alignItems: 'center', gap: 0.5 }}
              onClick={() => navigate("/order")}
            >
              <ReceiptIcon fontSize="small" /> Orders
            </Box>

            {/* LOGIN */}
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                borderRadius: "12px",
                px: 3,
                py: 1,
                fontWeight: 700,
                boxShadow: "0 10px 30px rgba(79,92,241,.4)",
                textTransform: "none",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 15px 40px rgba(79,92,241,.5)",
                },
              }}
            >
              Login / Register
            </Button>
          </Box>

          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              mx: "auto",
              overflowX: "hidden",
              minWidth: 0,
            }}
          >

            {/* TOP CATEGORY BAR */}
            <Box
              sx={{
                top: 64,
                zIndex: 900,
                background: "linear-gradient(180deg,#f5f7ff,#ffffff)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                px: "12px",
                py: "4px",
                height: "68px",
                minHeight: "68px",
                overflowX: "auto",
                whiteSpace: "nowrap",
                width: "100%",
                flexShrink: 0,
              }}


            >
              {categories.map((item, index) => {
                const isActive = selected === item;

                return (
                  <Box
                    key={index}
                    onClick={() => setSelected(item)}
                    sx={{

                      flex: "0 0 auto",
                      height: 34,

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      px: 2.5,
                      borderRadius: "999px",

                      fontSize: "13px",
                      fontWeight: 700,
                      lineHeight: "13px",
                      whiteSpace: "nowrap",

                      cursor: "pointer",

                      color: isActive ? "#fff" : "#4f5cf1",
                      background: isActive
                        ? "linear-gradient(135deg,#4f5cf1,#7b85ff)"
                        : "#ffffff",

                      border: isActive
                        ? "none"
                        : "1px solid rgba(79,92,241,.35)",

                      boxShadow: isActive
                        ? "0 6px 16px rgba(79,92,241,.35)"
                        : "none",

                      transition: "all .2s ease",

                      "&:hover": {
                        background: isActive
                          ? "linear-gradient(135deg,#5f6cff,#8b95ff)"
                          : "rgba(79,92,241,.08)",
                      },
                    }}
                  >
                    {item}
                  </Box>

                );
              })}
            </Box>



            {/* CATEGORY CONTENT */}
            <Box sx={{ mt: 3 }}>
              {selected &&
                marketingCategoryProducts[selected] &&
                renderProductSections(marketingCategoryProducts[selected])}
            </Box>

          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },


            }}
          />


          {/* middle images  */}
          {selected === null || selected === "Home" ? (
            <>
              <Box
                sx={{
                  maxWidth: "1100px",
                  mx: "auto",
                  mt: 2,
                  position: "relative",
                  height: { xs: 350, md: 420 },
                  borderRadius: "16px",
                  overflow: "hidden",
                }}
              >

                {/* BLUR BACKGROUND */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${heroSlides[slide].image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "blur(20px)",
                    transform: "scale(1.1)", // avoid edges showing
                    zIndex: 0,
                  }}
                />

                {/* DARK OVERLAY (for readability) */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(0,0,0,0.5)",
                    zIndex: 1,
                  }}
                />

                {/* CONTENT */}
                <Box
                  sx={{
                    position: "relative",
                    zIndex: 2,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: { xs: 2, md: 6 },
                    color: "#fff",
                  }}
                >

                  {/* LEFT TEXT */}
                  <Box sx={{ maxWidth: "50%" }}>
                    <Box sx={{ fontSize: "28px", fontWeight: "bold", mb: 1 }}>
                      {heroSlides[slide].title}
                    </Box>

                    <Box sx={{ fontSize: "18px", mb: 1 }}>
                      {heroSlides[slide].subtitle}
                    </Box>

                    <Box sx={{ fontSize: "14px", opacity: 0.9, mb: 2 }}>
                      {heroSlides[slide].desc}
                    </Box>

                    <Box
                      sx={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#fff",
                        background: "linear-gradient(135deg, #ff9900, #ff6600)",
                        px: 3,
                        py: 1.5,
                        borderRadius: 3,
                        display: "inline-block",
                        boxShadow: "0 4px 15px rgba(255, 153, 0, 0.4)",
                        mb: 3,
                        textAlign: "center",
                      }}
                    >
                      {heroSlides[slide].offer}
                    </Box>

                    <Button
                      variant="contained"
                      sx={{
                        background: "linear-gradient(135deg, #ff9900, #e68a00)",
                        color: "#000",
                        fontWeight: "bold",
                        fontSize: "16px",
                        px: 5,
                        py: 2,
                        borderRadius: 3,
                        textTransform: "none",
                        boxShadow: "0 6px 20px rgba(255, 153, 0, 0.5)",
                        border: "2px solid #fff",
                        "&:hover": {
                          background: "linear-gradient(135deg, #e68a00, #cc7a00)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 8px 25px rgba(255, 153, 0, 0.6)",
                        },
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => setSelected(heroSlides[slide].category)}
                    >
                      Shop Now
                    </Button>
                  </Box>

                  {/* RIGHT IMAGE */}
                  <Box
                    component="img"
                    src={heroSlides[slide].image}
                    sx={{
                      width: { xs: "45%", md: "40%" },
                      height: "80%",
                      objectFit: "cover",
                      borderRadius: "12px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
                    }}
                  />
                </Box>

                {/* INDICATORS */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 20,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: 1,
                    zIndex: 3,
                  }}
                >
                  {heroSlides.map((_, index) => (
                    <Box
                      key={index}
                      onClick={() => setSlide(index)}
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: slide === index ? "#fff" : "rgba(255,255,255,0.5)",
                        cursor: "pointer",
                        transition: "0.3s",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                      }}
                    />
                  ))}
                </Box>

                {/* LEFT ARROW */}
                <IconButton
                  onClick={() =>
                    setSlide((prev) =>
                      prev === 0 ? heroSlides.length - 1 : prev - 1
                    )
                  }
                  sx={{
                    position: "absolute",
                    left: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#fff",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.5)",
                    },
                    zIndex: 3,
                  }}
                >
                  <ArrowBackIos sx={{ fontSize: 24 }} />
                </IconButton>

                {/* RIGHT ARROW */}
                <IconButton
                  onClick={() =>
                    setSlide((prev) =>
                      prev === heroSlides.length - 1 ? 0 : prev + 1
                    )
                  }
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#fff",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.5)",
                    },
                    zIndex: 3,
                  }}
                >
                  <ArrowForwardIos sx={{ fontSize: 24 }} />
                </IconButton>

              </Box>

              {renderHomeOffers()}

            </>
          ) : null}


        </CardContent>
      </Card>
    </Box>
  );
};

export default Marketing;
